import Errors from './Errors.js'

export default class Form {
  /**
   * Create a new Form instance.
   *
   * @param {object} data
   */
   constructor(data, fieldsToReset = null) {
    this.originalData = data;
    this.working = false;
    this.recentSuccess = false;

    for (let field in data) {
      this[field] = data[field];
    }

    fieldsToReset ? this.fieldsToReset = fieldsToReset : this.fieldsToReset = data

    this.errors = new Errors();
  }


  /**
   * Fetch all relevant data for the form.
   */
   data() {
    let data = {};

    for (let property in this.originalData) {
      data[property] = this[property];
    }

    return data;
  }


  /**
   * Reset the form fields.
   */
   reset() {
    for (let field in this.fieldsToReset) {
      if (this[field] instanceof Array) {
        this[field] = []
      } else if (this[field] === '' || isNaN(this[field])) {
        this[field] = ''
      } else {
        this[field] = 0
      }
    }

    this.errors.clear();
  }


  /**
   * Send a POST request to the given URL.
   * .
   * @param {string} url
   */
   post(url) {
    return this.submit('post', url);
  }


  /**
   * Send a PUT request to the given URL.
   * .
   * @param {string} url
   */
   put(url) {
    return this.submit('put', url);
  }


  /**
   * Send a PATCH request to the given URL.
   * .
   * @param {string} url
   */
   patch(url) {
    return this.submit('patch', url);
  }


  /**
   * Send a DELETE request to the given URL.
   * .
   * @param {string} url
   */
   delete(url) {
    return this.submit('delete', url);
  }


  /**
   * Submit the form.
   *
   * @param {string} method
   * @param {string} url
   */
   submit(method, url) {
    this.working = true;
    return new Promise((resolve, reject) => {
      axios({
        method,
        url,
        data: this.data(),
      })
      .then(response => {
        this.onSuccess(response.data);

        resolve(response.data);
      })
      .catch(error => {
        this.onFail(error.response.data.errors);

        reject(error.response.data.errors);
      })
      .then(() => {
        this.working = false;
      });
    });
  }


  /**
   * Handle a successful form submission.
   *
   * @param {object} data
   */
    onSuccess(data) {
      this.reset();
      this.recentSuccess = true;
    }


  /**
   * Handle a failed form submission.
   *
   * @param {object} errors
   */
   onFail(errors) {
    this.errors.record(errors);
  }

  /**
   * Returns true if the form is performing a request
   */
  isWorking() {
    return this.working;
  }

  hadRecentSuccess() {
    return this.recentSuccess;
  }
}



// WEBPACK FOOTER //
// ./resources/js/Form.js